import React from "react";
import * as actions from '../actions';
import { format } from "date-fns";
import { Popup } from "./sharedComponents";
import { ActiveModifiers, DateRange, DayPicker, SelectRangeEventHandler } from 'react-day-picker';

interface Props {
    selectedDate?: Date;
    onDateSelected({ date, range, activeModifiers, popupKey }: { date?: Date, range?: DateRange, activeModifiers: ActiveModifiers, popupKey: string }): void;
    formatDate?: (date?: number | Date) => string;
    mode?: 'range' | 'default' | 'single' | 'multiple';
    closeOnSelected?: boolean;
    placeholder?: string;
	restrictedDates?: Date[];
	isVertical?: boolean;
}

function defaultFormat(date?: number | Date) {
	return date? format(date, 'MM/dd/yyyy'): '';
}

const POPUP_KEY = 'day-picker-input';
export function DayPickerInput({ selectedDate, onDateSelected, formatDate = defaultFormat, isVertical, placeholder, mode = 'single', closeOnSelected = true, restrictedDates = [] }: Props) {
	const renderDate = (selectedDate && selectedDate instanceof Date && !isNaN(selectedDate as any))? selectedDate: undefined;
	const onSelected: SelectRangeEventHandler = (range, selectedDay, activeModifiers, e) => {
		if(onDateSelected) {
			onDateSelected({ date: selectedDay, range, activeModifiers, popupKey: POPUP_KEY });
		}

		if(closeOnSelected) {
			actions.deleteModal({ key: POPUP_KEY });
		}
	}

	const openPicker = (e) => {
		if(actions.modalExists({ key: POPUP_KEY}) ) {
			return;
		}
        
		const popup = <Popup target={e.target} isVertical={ isVertical }><div className="content"><DayPicker mode={ mode as any } selected={ renderDate } onSelect={ onSelected } modifiers={ { restricted: restrictedDates }} modifiersClassNames={ { restricted: 'restricted' } } /></div></Popup>;

		actions.pushModal({ key: POPUP_KEY, component: popup });
	}

	return <input type='text' className="dataList datePicker" placeholder={ placeholder } readOnly={ true } value={ renderDate? formatDate(renderDate): '' } onFocus={ openPicker } />
}